import { useLocation } from "react-router-dom";
import { displaySurvey } from "../UserSplitTest/library/survey";
import { getSurveyConfig, onDidomiCMPHidden } from "./utils";
import { useEffect } from "react";

/**
 * This component activates Conductrics survey display if config survey conditions are
 * met and the privacy notification is not displayed
 * @returns null
 */

const ConductricsSurvey = () => {
    const location = useLocation();
    const surveyConfigs = getSurveyConfig();

    useEffect(() => {
        if (!surveyConfigs) return;
        const surveyKeys = Object.keys(surveyConfigs);

        const activeSurveyKey =
            //first look for any survey config keys that exactly match the current path and are enabled
            surveyKeys.find((key) => {
                return (
                    key === location?.pathname &&
                    surveyConfigs[key].enabled === true
                );
            }) ||
            //otherwise, lets look for ones that are substring matchable
            surveyKeys.find((key) => {
                return (
                    surveyConfigs[key].substringMatch === true &&
                    location?.pathname.includes(key) &&
                    surveyConfigs[key].enabled === true
                );
            });
        if (!activeSurveyKey) return;

        onDidomiCMPHidden(() => {
            displaySurvey(surveyConfigs[activeSurveyKey].trigger);
        });
    }, [location?.pathname]);

    return null;
};

export default ConductricsSurvey;
